import { render, staticRenderFns } from "./GloboGraphicsFieldRenderer.vue?vue&type=template&id=28d9c48d&scoped=true"
import script from "./GloboGraphicsFieldRenderer.vue?vue&type=script&lang=js"
export * from "./GloboGraphicsFieldRenderer.vue?vue&type=script&lang=js"
import style0 from "./GloboGraphicsFieldRenderer.vue?vue&type=style&index=0&id=28d9c48d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d9c48d",
  null
  
)

export default component.exports